export default __webpack_public_path__ + "fba247781b4dfeec7c1e3c226fe9c45e.png";